{
  "register-pin-page": {
    "buttons": {
      "resend": "Znovu odeslat",
      "submit": "Odeslat"
    },
    "text": {
      "email-check": "TIPY: Zkontrolujte si prosím také složku se spamem nebo zkontrolujte, zda je váš e-mail <strong>{{ email }}</strong> správný, případně použijte pro registraci jiný e-mail!",
      "in-second": "v {{seconds}} s",
      "not-receive-pin": "Neobdrželi jste žádný PIN?",
      "pin-incorrect": "PIN je nesprávný. Zkontrolujte jej prosím ve svém e-mailu a zkuste to znovu.",
      "verify-account": "Ověření účtu",
      "verify-account-hint": "Potvrzovací pin vám bude zaslán na váš e-mail <strong>{{ email }}</strong>."
    }
  }
}
